// Custom components
import React from "react";

function InputField(props) {
  const { label, id, extra, type, placeholder, variant, state, disabled } =
    props;

  return (
    <div className={`${extra}`}>
      <label
        htmlFor={id}
        className={`text-sm text-white ${
          variant === "auth" ? "ml-1.5 font-medium" : "ml-3 font-bold"
        }`}
      >
        {label}
      </label>
      <input
        disabled={disabled}
        type={type}
        id={id}
        placeholder={placeholder}
        className={`mt-2 flex h-12 w-full items-center justify-center rounded-xl border bg-white/0 p-3 text-sm outline-none ${
          disabled === true
            ? "!border-none !bg-gray-100 !bg-white/5 placeholder:!text-[rgba(255,255,255,0.15)]"
            : state === "error"
            ? " !border-red-400 !text-red-400 placeholder:!text-red-400"
            : state === "success"
            ? " !border-green-400 !text-green-400 placeholder:!text-green-400"
            : "!border-white/10 border-gray-200 text-white"
        }`}
        {...props}
      />
    </div>
  );
}

export default InputField;
